<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type=false ref="head_page"></head_page>
      </el-header>
      <el-main style="margin-top:15px">
        <head_menu :has-back=true @go-back-click="goBack">
        </head_menu>
        <b-container fluid style="margin-top: 20px; padding: 0;">
          <!-- User Interface controls -->
          <b-row>
            <b-col>
              <b-button-group style="width:100%">
                <b-button :class={blue:allClicked} @click="getPackageList('all')" variant="outline-primary">{{$t('message.all_packages')}}</b-button>
                <b-button :class={blue:publishedClicked} @click="getPackageList('published')" variant="outline-primary">{{$t('message.published_packages_only')}}</b-button>
                <b-button :class={blue:unpublishedClicked} @click="getPackageList('unpublished')" variant="outline-primary">{{$t('message.unpublished_packages_only')}}</b-button>
                <b-button :class={blue:expiredClicked} @click="getPackageList('expired')" variant="outline-primary">{{$t('message.expired_packages')}}</b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <b-row v-if="false">
            <b-col lg="6" class="my-1">
              <b-form-group
                label="Sort"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="sortBySelect"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-select v-model="sortBy" id="sortBySelect" :options="sortOptions" class="w-75">
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>
                  <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="6" class="my-1">
              <b-form-group
                label="Initial sort"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="initialSortSelect"
                class="mb-0"
              >
                <b-form-select
                  v-model="sortDirection"
                  id="initialSortSelect"
                  size="sm"
                  :options="['asc', 'desc', 'last']"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="6" class="my-1">
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="6" class="my-1">
              <b-form-group
                label="Filter On"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                description="Leave all unchecked to filter on all data"
                class="mb-0">
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="name">Name</b-form-checkbox>
                  <b-form-checkbox value="age">Age</b-form-checkbox>
                  <b-form-checkbox value="isActive">Active</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>

            <b-col sm="5" md="6" class="my-1">
              <b-form-group
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              > 
                <b-form-select
                  id="perPageSelect"
                  size="sm"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            small
            stacked="md"
            :items="published_package_list"
            :fields="fields"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            :fixed="true" 
          >
            <template #cell(created_at)="row">
              <div style="display:flex;flex-wrap:nowarp">
                <div style="display:inline-block;margin-right:5px">
                  <span @click="row.toggleDetails" style="user-select:none;cursor:pointer">
                    <b-iconstack font-scale="1" rotate="90">
                    <b-icon stacked icon="chevron-right" shift-h="4" variant="primary"></b-icon>
                    </b-iconstack>
                  </span>
                </div>
                  
                <div style="display:inline-block">
                  {{ row.value.split(" ")[0] }}
                  {{ row.value.split(" ")[1] }}
                </div>
              </div>
            </template>

            <template #cell(name)="row">
              {{ row.value.first }} {{ row.value.last }}
            </template>

            <template #cell(publish_status)="row">
              <b-button variant="outline-primary" v-if="row.value==0" size="sm" @click="publish(row.item, row.index, $event.target)" class="mr-1" style="size:5px;margin:0">
                <span>{{$t('message.Publish')}}</span>
              </b-button>
              <b-button variant="outline-primary" v-if="row.value==1" size="sm" @click="deleteP(row.item, row.index, $event.target)" class="mr-1" style="size:5px;margin:0">
                <span>{{$t('message.Delete')}}</span>
              </b-button>
              <b-button v-if="false" variant="outline-primary" size="sm" @click="edit(row.item, row.index, $event.target)" class="mr-1" style="size:5px;margin:0">
                <span>{{$t('message.Edit')}}</span>
              </b-button>
              <b-button variant="outline-primary" size="sm" @click="view(row.item, row.index, $event.target)" class="mr-1" style="size:5px;margin:0">
                <span>{{$t('message.View')}}</span>
              </b-button>
            </template>

            <template #row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key" style="list-style:none">
                    <div v-if="key=='package_price' || key=='viewed_impression' || key=='bus_line_qty'|| key=='bus_body_qty'">
                      {{ key.split('_').join(' ').replace(/^\S/, s => s.toUpperCase()) }}: {{ value }}
                    </div>
                  </li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <!-- Info modal -->
          <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
            <pre>{{ infoModal.content }}</pre>
          </b-modal>
        </b-container>


      </el-main>
    </el-container>

  </div>

</template>

<script>
  import head_page from './components/head_page.vue';
  import head_menu from './components/head_menu.vue';
  import axios from 'axios';
  import _global from './components/global.vue';
  export default {
    name: 'choose_city',
    data() {
      return {
        flag_button:'',
        published_package_list:[],
        tableDataCommercial: [],
        loading: false,
        client_name: '',
        client_logo_image: '',
        value: '',
        tableData: [],
        reportParam:'',
        media_format_options : [],
        rank_options : [],
        audience_info : [],
        gender_options : [],
        age_options : [],
        spend_power_options : [],
        interest_options : [],
        showColor: false,
        status_options: [{
          value: '1',
          label: this.$t('message.Draft')
        }, {
          value: '2',
          label: this.$t('message.Discussion')
        }, {
          value: '3',
          label: this.$t('message.Sent')
        }, {
          value: '4',
          label: this.$t('message.Win')
        }, {
          value: '5',
          label: this.$t('message.Fail')
        }],
        items: [
            { isActive: true, age: 40, name: { first: 'Dickerson', last: 'Macdonald' } },
            { isActive: false, age: 21, name: { first: 'Larsen', last: 'Shaw' } },
            {
              isActive: false,
              age: 9,
              name: { first: 'Mini', last: 'Navarro' },
              _rowVariant: 'success'
            },
            { isActive: false, age: 89, name: { first: 'Geneva', last: 'Wilson' } },
            { isActive: true, age: 38, name: { first: 'Jami', last: 'Carney' } },
            { isActive: false, age: 27, name: { first: 'Essie', last: 'Dunlap' } },
            { isActive: true, age: 40, name: { first: 'Thor', last: 'Macdonald' } },
            {
              isActive: true, 
              age: 87,
              name: { first: 'Larsen', last: 'Shaw' },
              _cellVariants: { age: 'danger', isActive: 'warning' }
            },
            { isActive: false, age: 26, name: { first: 'Mitzi', last: 'Navarro' } },
            { isActive: false, age: 22, name: { first: 'Genevieve', last: 'Wilson' } },
            { isActive: true, age: 38, name: { first: 'John', last: 'Carney' } },
            { isActive: false, age: 29, name: { first: 'Dick', last: 'Dunlap' } }
          ],
          totalRows: 1,
          currentPage: 1,
          // perPage: 20,
          // pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          filterOn: [],
          infoModal: {
            id: 'info-modal',
            title: '',
            content: ''
          },
          allClicked:true,
          publishedClicked:false,
          unpublishedClicked:false,
          expiredClicked:false,
      }
    },
    computed: {
      day: function() {
        let week;
        let date = new Date();
        if (date.getDay() == 0) week = this.$t('message.Sunday')
        if (date.getDay() == 1) week = this.$t('message.Monday')
        if (date.getDay() == 2) week = this.$t('message.Tuesday')
        if (date.getDay() == 3) week = this.$t('message.Wednesday')
        if (date.getDay() == 4) week = this.$t('message.Thursday')
        if (date.getDay() == 5) week = this.$t('message.Friday')
        if (date.getDay() == 6) week = this.$t('message.Saturday')
      
        return week;
      },
      date: function() {
        let date_org = new Date();
        let date_arr = String(date_org).split(" ");
        if (date_arr[1] == 'Jan') date_arr[1] = this.$t('message.Jan')
        if (date_arr[1] == 'Feb') date_arr[1] = this.$t('message.Feb')
        if (date_arr[1] == 'Mar') date_arr[1] = this.$t('message.Mar')
        if (date_arr[1] == 'Apr') date_arr[1] = this.$t('message.Apr')
        if (date_arr[1] == 'May') date_arr[1] = this.$t('message.May')
        if (date_arr[1] == 'Jun') date_arr[1] = this.$t('message.Jun')
        if (date_arr[1] == 'Jul') date_arr[1] = this.$t('message.Jul')
        if (date_arr[1] == 'Aug') date_arr[1] = this.$t('message.Aug')
        if (date_arr[1] == 'Sep') date_arr[1] = this.$t('message.Sep')
        if (date_arr[1] == 'Oct') date_arr[1] = this.$t('message.Oct')
        if (date_arr[1] == 'Nov') date_arr[1] = this.$t('message.Nov')
        if (date_arr[1] == 'Dec') date_arr[1] = this.$t('message.Dec')
        return date_arr[2] + ' ' + date_arr[1] + ' ' + date_arr[3];
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      isPublished(publish){
        publish
        this.published_package_list
        return true
      },
      fields(){
        return  [
            { key: 'created_at', label: this.$t('message.Created_at'), sortable: true, sortDirection: 'desc' },
            { key: 'package_name', label: this.$t('message.Package_name'), sortable: true, class: 'text-center' },
            { key: 'city', label: this.$t('message.City'), sortable: true, class: 'text-center' },
            { key: 'valid_period_start', label: this.$t('message.Validation_Start'), sortable: true, class: 'text-center' },
            { key: 'valid_period_end', label: this.$t('message.Validation_End'), sortable: true, class: 'text-center' },
            { key: 'created_by', label: this.$t('message.Created_by'), sortable: true, class: 'text-center' },
            { key: 'bu_city', label: this.$t('message.Team'), sortable: true, class: 'text-center' },
            // {
            //   key: 'isActive',
            //   label: 'Is Active', 
            //   formatter: (value, key, item) => {
            //     return value ? 'Yes' : 'No'
            //   },
            //   sortable: true,
            //   sortByFormatted: true,
            //   filterByFormatted: true, 
            //   class: 'text-center'
            // },
            { key: 'publish_status', label: this.$t('message.Actions') , class: 'text-center'}
          ]
      }
    },
    components: {
      head_page,
      head_menu
    },
    created() {
      this.loading = true;
      if (JSON.parse(sessionStorage.getItem('User')) != null) {
        this.user = JSON.parse(sessionStorage.getItem('User')).split('.')[0].toUpperCase();
      }
    },
    mounted() {
      this.$refs.head_page.update_user_name();
      this.lang = JSON.parse(sessionStorage.getItem('lang'));
      this.$i18n.locale = this.lang;
      this.$refs.head_page.switchLang(this.lang);
      this.getHistoryData()
      this.loading = false
      let obj = new Object()
      obj.email = JSON.parse(sessionStorage.getItem('User'))
      this.totalRows = this.items.length

      this.getPackageList('all')
    },
    updated() {},
    methods: {
      view(item, index, e){
        let a = JSON.parse(item.report_param)
        this.$store.state.package=a
        this.$router.push({
          path: '/package_confirm',
          query: {
            chosen_city: a.city,
            view:1
          }
        })
      },
      edit(item, index, e){
        let a = JSON.parse(item.report_param)
        this.$store.state.package.Data_Information = a.Data_Information;
        this.$store.state.package.Data_Options = a.Data_Options;
        this.$store.state.package.edit = a;
        this.$router.push({
          path: '/package_selection',
          query: {
            chosen_city: a.city,
            edit:1
          }
        })
      },
      deleteP(item, index, e){
        let api_url = _global.serverSrc + '/package_publish/?format=json';
        let obj = {'publish':0,'package_id':item.package_id}
        var _self = this;
        if (this.flag_button=="expired"){
          //删掉这条记录
          //把hide变成1就不显示
          api_url = _global.serverSrc + '/package_hide/?format=json';
          obj = {'hide':1,'package_id':item.package_id}
          this.$confirm('此操作将永久删除该套装, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });

        }else{

        
          
        }
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url,obj).then(response => {
            if (response.data) {
              //this.$store.state.package.published_package = response.data
            }
            _self.loading = false;
          })
          .catch(function(error) {
            _self.loading = false;
          });
          this.$router.go(0)
      },
      publish(item, index, e){
        let api_url = _global.serverSrc + '/package_publish/?format=json';
        let obj = {'publish': 1,'package_id': item.package_id}
        var _self = this;
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url,obj).then(response => {
            if (response.data) {
              //this.$store.state.package.published_package = response.data
            
            }
            _self.loading = false;
          })
          .catch(function(error) {
            _self.loading = false;
          });
          this.$router.go(0)
      },
      
      getPackageList(flag){
        
        this.flag_button = flag
        // let auth = JSON.parse(sessionStorage.getItem('UserAuthority'))
        // if (auth.is_national){
        //   city_name="all"
        // }
        // else if (auth.view_nanjing){
        //   city_name="Nanjing"
        // }
        // else if (auth.view_wuhan){
        //   city_name="Wuhan"
        // }
        //权限相关
        let api_url = _global.serverSrc + '/package_display/'
        var _self = this;

        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.package_publish_status = flag

        this.$axios.post(api_url,obj).then(response => {
            if (response.data.package_list) {
              if (flag=='published'){
                this.published_package_list=[]
                this.publishedClicked=true
                this.unpublishedClicked=false
                this.expiredClicked=false
                this.allClicked=false
                for (let ele of response.data.package_list){
                  if (ele.publish_status ==1){
                    this.published_package_list.push(ele)
                  }
                }
              }else if(flag=='unpublished'){
                this.published_package_list=[]
                this.unpublishedClicked=true
                this.publishedClicked=false
                this.expiredClicked=false
                this.allClicked=false
                for (let ele of response.data.package_list){
                  if (ele.publish_status ==0){
                    this.published_package_list.push(ele)
                  }
                }
              }else if(flag=='expired'){
                this.published_package_list=[]
                this.expiredClicked=true
                this.publishedClicked=false
                this.unpublishedClicked=false
                this.allClicked=false
                for (let ele of response.data.package_list){
                  ele.publish_status =1
                  if (ele.hide!=1){
                    this.published_package_list.push(ele)
                  }
                }
              }else{
                this.published_package_list = response.data.package_list
                this.allClicked=true
                this.publishedClicked=false
                this.unpublishedClicked=false
                this.expiredClicked=false
              }
              //this.$store.state.package.published_package = response.data
            
            }
            _self.loading = false;
            this.published_package_list.splice()
          })
          .catch(function(error) {
            _self.loading = false;
          });
      },
       info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      handleBlur:function(val,index){
          setTimeout(
            ()=>{
              this.tableData[index].isChanged = false
            },300
          )
      },
      handleChange:function(val,index){
        if (val.isChanged == true){
          this.tableData[index].isChanged = false
          this.tableData[index].status = val.status
          //发送信息更改数据库
          let api_url = _global.serverSrc + '/status_check/?format=json';
          let obj = {}
          obj.reference_id = val.id
          obj.status_code = this.inverseProposalStatusChange(val.status)
          obj.email = JSON.parse(sessionStorage.getItem('User'))
          this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.status_check != null) {
              if (response.data.status_check[0].is_ok==1){
                this.$notify({
                  message: this.$t('message.The_data_is_successfully_uploaded'),
                  position: 'top-left'
                });
                
              }else{
                this.$notify({
                  message: this.$t('message.No_Authority'),
                  position: 'top-left'
                });
              }
              this.$router.go(0)
            }
          })
          .catch(e => {
          })
        
        }
        
      },
      handleSelect:function(val,index){
        if (val.isChanged == false){
          this.tableData[index].isChanged = true
        }
      },
      goBack(){
        this.$router.back()
      },
      viewAction(row){
        //1从数据库拿数据
        let api_url = _global.serverSrc + '/user_operation_history/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.id = row.id
        this.$axios.post(api_url, obj)
        .then(response => {
          if (response.data.user_operation_history != null) {
            let data = JSON.parse(response.data.user_operation_history[0].report_param)
            sessionStorage.setItem('Data_History', JSON.stringify(data))
            this.$router.push({
              path: '/board'
            });
          }
        })
        .catch(e => {
        })
      },
      handleUpload(file) {

        this.client_logo_image = file.raw
        let FR = new FileReader();
        FR.readAsDataURL(this.client_logo_image);

        FR.onload = () => {
          this.client_logo_image = FR.result
        }
      },
      handleEdit(index, row) {
        let api_url = _global.serverSrc + '/user_operation_history/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.id = row.id
        this.$axios.post(api_url, obj)
        .then(response => {
          if (response.data.user_operation_history != null) {
            let data = JSON.parse(response.data.user_operation_history[0].report_param)
            let lang = JSON.parse(sessionStorage.getItem("lang"));
            let user = JSON.parse(sessionStorage.getItem("User"));
            let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
            sessionStorage.clear();
            sessionStorage.setItem("lang", JSON.stringify(lang));
            sessionStorage.setItem("User", JSON.stringify(user));
            sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
            sessionStorage.setItem('Data_History', JSON.stringify(data))
            this.createDataInformationFromHistory(data)
            this.createDataMapFromHistory(data)
            this.createOptionsFromHistory(data)
            this.$router.push({
              path: '/map',
              query: {
                chosen_city: data.city
              }
            })
          }
        })
        .catch(e => {
        })
        
      },
      createDataInformationFromHistory(dataHistory){
        let obj={}
        obj.data_audience=dataHistory.data_audience
        obj.data_poi = this.changeBooleanInverse(dataHistory.data_poi)
        let obj2={}
        obj2.value_media_format = dataHistory.data_media
        obj2.value_rank = dataHistory.data_rank
        obj.data_media_rank = obj2
        obj.date = Number(dataHistory.date)*1000
        obj.value_duration = dataHistory.duration
        obj.isEdit = 1
        sessionStorage.setItem('Data_Information', JSON.stringify(obj))
      },
      createDataMapFromHistory(dataHistory){
        
      },
      createOptionsFromHistory(dataHistory){
        sessionStorage.setItem('Data_Options', JSON.stringify(dataHistory.options))
      },
      
      changeBooleanInverse(data_poi){
        if (data_poi == 0){
          data_poi = false
        } else if (data_poi == 1){
          data_poi = true
        }else{
          for (let ele in data_poi){
            if (data_poi[ele] == 1){
              data_poi[ele] = true
            }else{
              data_poi[ele] = false
            }
          }
        }
        return data_poi
      },
      handleDelete(index, row) {
      },
      goHome: function(event) {
        this.$router.push({
          path: '/choose_city'
        });
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        let user = JSON.parse(sessionStorage.getItem("User"));
        let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
        sessionStorage.clear();
        sessionStorage.setItem("lang", JSON.stringify(lang));
        sessionStorage.setItem("User", JSON.stringify(user));
        sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      },
      backToLogin: function(event) {
        this.$router.push({
          path: '/',
        });
      },
      updateStatusOption: function(){
        this.status_options[0].label = this.$t('message.Draft')
        this.status_options[1].label = this.$t('message.Discussion')
        this.status_options[2].label = this.$t('message.Sent')
        this.status_options[3].label = this.$t('message.Win')
        this.status_options[4].label = this.$t('message.Fail')
      },
      proposalStatusChange: function(val){
        this.updateStatusOption();
        for(let ele in this.status_options){
          if (this.status_options[ele].value == val){
            return this.status_options[ele].label
          }
        }
      },
      inverseProposalStatusChange: function(val){
        for(let ele in this.status_options){
          if (this.status_options[ele].label == val){
            return this.status_options[ele].value
          }
        }
      },
      getHistoryData: function(data) {
        let api_url = _global.serverSrc + '/user_history/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data != null) {
              for (let ele of response.data.user_history) {
                let tmp = {}
                tmp.id = ele.reference_id
                tmp.createdAt = ele.created_at
                tmp.city = ele.city
                tmp.clientName = ele.client_name
                tmp.campaignStart = ele.campaign_start
                tmp.campaignEnd = ele.campaign_end
                tmp.createdBy = ele.created_by
                tmp.impressions = Number(ele.viewed_impression).toLocaleString()
                tmp.total_media_budget = Number(ele.estimated_cost).toLocaleString()
                tmp.total_bus_line = Number(ele.number_bus)
                tmp.team = ele.bu_city
                tmp.status = this.proposalStatusChange(ele.proposal_status)
                tmp.isChanged = false
                tmp.status_options = this.createSelfOption(ele.proposal_status)
                this.tableData.push(tmp)
              }
            }
          })
          .catch(e => {
          })
      },
      createSelfOption: function(status_code){
        let options = [...this.status_options]
        switch (status_code) {
          case 5: //fail
                  options.shift()
                  options.shift()
                  options.shift()
                  options.shift()
                  break;
          case 4: //win
            
                  options.shift()
                  options.shift()
                  options.shift()
                  options.pop()
                  break;
          case 3: //sent
                  options.shift()
                  options.pop()
                  options.pop()
                  break;
          case 2: //discussion
                  options.shift()
                  break;
          case 1: //draft
                  options.shift()
                  options.pop()
                  options.pop()
                  break;
          default:
            break;
        }

        return options
      },
      //用了vuex后改，原函数在information.vue
      setDataFromDB_media_info(_self, arr, lang) {
        if (lang == "cn") {
          for (let ele in arr) {
            if (arr[ele].content == "media format") {
              _self.media_format_options.push({
                value: arr[ele].code,
                label: arr[ele].label_cn
              });
            } else if (arr[ele].content == "rank") {
              _self.rank_options.push({
                value: arr[ele].code,
                label: arr[ele].label_cn
              });
            }
          }
        } else {
          for (let ele in arr) {
            if (arr[ele].content == "media format") {
              _self.media_format_options.push({
                value: arr[ele].code,
                label: arr[ele].label
              });
            } else if (arr[ele].content == "rank") {
              _self.rank_options.push({
                value: arr[ele].code,
                label: arr[ele].label
              });
            }
          }
        }
      
      
      },
      getMediaInfo(data) {
        let api_url = _global.serverSrc + '/media_info/';
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        var _self = this;
        axios.post(api_url, obj)
          .then(response => {
            if (response.data) {
              _self.setDataFromDB_media_info(_self, response.data.media_info, _self.$i18n.locale)
            }
          })
          .catch(function(error) {
          });
      },
      sortOptionsByValue: function(options) {
        var i = options.length,
          j;
        var tempExchangVal;
        while (i > 0) {
          for (j = 0; j < i - 1; j++) {
            if (options[j].value > options[j + 1].value) {
              tempExchangVal = options[j];
              options[j] = options[j + 1];
              options[j + 1] = tempExchangVal;
            }
          }
          i--;
        }
      },
      setDataFromDB_audience_info(_self, arr, lang) {
        if (lang == "cn") {
          for (let ele in arr) {
            if (_self.audience_info[ele].content == "gender") {
              _self.gender_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            } else if (_self.audience_info[ele].content == "age") {
              _self.age_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            } else if (_self.audience_info[ele].content == "spend power") {
              _self.spend_power_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            } else if (_self.audience_info[ele].content == "interest") {
              _self.interest_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label_cn
              });
            }
      
          }
        } else {
          for (let ele in arr) {
            if (_self.audience_info[ele].content == "gender") {
              _self.gender_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            } else if (_self.audience_info[ele].content == "age") {
              _self.age_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            } else if (_self.audience_info[ele].content == "spend power") {
              _self.spend_power_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            } else if (_self.audience_info[ele].content == "interest") {
              _self.interest_options.push({
                value: _self.audience_info[ele].code,
                label: _self.audience_info[ele].label
              });
            }
      
          }
        }
      
      },
      async getAudienceInfo() {
        let api_url = _global.serverSrc + '/audience_info/';
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        var _self = this;
        await this.$axios.post(api_url, obj)
          .then(function(response) {
            if (response.data) {
              _self.audience_info = response.data.audience_info;
              //初始化
              _self.gender_options = [];
              _self.age_options = [];
              _self.spend_power_options = [];
              _self.interest_options = [];
      
              _self.setDataFromDB_audience_info(_self, _self.audience_info, _self.$i18n.locale);
              _self.sortOptionsByValue(_self.gender_options);
              _self.sortOptionsByValue(_self.age_options);
              _self.sortOptionsByValue(_self.spend_power_options);
              _self.sortOptionsByValue(_self.interest_options);
            }
          })
          .catch(function(error) {
          });
      },

    }
  }
</script>

<style lang="scss" scoped>

  .circle{
    border-radius: 100%;
    margin: 0.65em 0 0 8em;
    padding:4px;
    width: 8px;
    height: 8px;
  }

  /deep/ td div {
    word-break:break-all;
  }
</style>
